"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const snap_ui_1 = require("@teamsnap/snap-ui");
const React = __importStar(require("react"));
const useAmpli_1 = require("src/hooks/useAmpli");
const LoginModal_1 = require("../login/LoginModal");
const layouts_1 = require("../shared/layouts");
const useInvitation_1 = require("./useInvitation");
const CreateAccount = () => {
    const { newUser: { email, receivesNewsletter, password, birthdate, termsAndConditionsAccepted }, setUser, teamName, submitClaimInvite, errors, invitationLoading, invitationLoadError, birthdateRequired, onLogin, } = React.useContext(useInvitation_1.InvitationContext);
    const { identify, screenViewed, resetUser } = (0, useAmpli_1.useAmpli)();
    const [openTooltip, setOpenTooltip] = React.useState(false);
    const [loginModalOpen, setLoginModalOpen] = React.useState(false);
    React.useEffect(() => {
        resetUser();
    }, []);
    React.useEffect(() => {
        if (typeof birthdateRequired !== 'undefined') {
            // not undefined means experiment has been fetched
            identify({ experiment_audience_age_gating: birthdateRequired });
            screenViewed(useAmpli_1.AmplitudeScreenNames.CLAIM_INVITE);
        }
    }, [birthdateRequired]);
    React.useEffect(() => {
        if (errors?.termsViolated) {
            (0, useAmpli_1.accountBlocked)(errors.termsViolated, 'Ctn', useAmpli_1.AmplitudeScreenNames.CLAIM_INVITE);
        }
    }, [errors?.termsViolated]);
    const onSubmit = () => {
        submitClaimInvite();
    };
    if (invitationLoading) {
        return React.createElement(layouts_1.LoadingPageBlank, null);
    }
    if (invitationLoadError) {
        return (React.createElement(layouts_1.InvitePageWrapper, null,
            React.createElement("div", { "data-testid": "loading-error" }, "Something went wrong")));
    }
    return (React.createElement(layouts_1.InvitePageWrapper, null,
        React.createElement(layouts_1.InviteHeader, { className: "", headerText: "Welcome! Let's join your team:" }),
        teamName && React.createElement("p", { className: "sui-heading-md sui-text-gray-40 sui-text-center sui-mb-2" }, teamName),
        React.createElement("div", { className: "sui-block sui-w-full invite-form sui-mt-1" },
            React.createElement(snap_ui_1.Input, { label: "Email", required: true, name: "email", className: "sui-block sui-mb-2", onChange: (e) => {
                    // safari autofill workaround
                    e.preventDefault(); // read-only
                }, placeholder: "", inputProps: {
                    maxLength: 150,
                    inputMode: 'email',
                    readOnly: true,
                }, value: email || '', type: "email", errors: errors?.email ? [errors.email] : [], autocomplete: "email" }),
            React.createElement(snap_ui_1.Input, { label: "Create a password", required: true, name: "password", className: "sui-block sui-mb-2", helpText: "Password must include at least 8 characters.", onChange: (e) => {
                    setUser('password', e.target.value);
                }, placeholder: "", inputProps: { maxLength: 255 }, value: password || '', type: "password", errors: errors?.password ? [errors.password] : undefined, autocomplete: "new-password" }),
            birthdateRequired && (React.createElement("div", { className: "sui-mb-2" },
                React.createElement(snap_ui_1.Birthdate, { className: "sui-block sui-mt-2", name: "birthdate-validated", onChange: (e) => {
                        setUser('birthdate', e.toString());
                    }, required: true, value: birthdate || '', size: "default", errors: errors?.birthdate ? [errors.birthdate] : [] }),
                React.createElement(snap_ui_1.TooltipProvider, null,
                    React.createElement(snap_ui_1.Tooltip, { align: "start", content: "We verify age to ensure compliance with our terms of service for a safe and enjoyable app experience.", side: "top", open: openTooltip },
                        React.createElement(snap_ui_1.TooltipTrigger, { asChild: true, onClick: () => setOpenTooltip(!openTooltip) },
                            React.createElement("div", { className: "sui-flex help-text sui-cursor-pointer" },
                                React.createElement(snap_ui_1.Icon, { name: "info", size: "s" }),
                                React.createElement("span", { className: "sui-pl-1 sui-text-mobile-2" }, "Why we ask for date of birth"))))))),
            React.createElement(snap_ui_1.Checkbox, { className: "sui-mb-2", name: "receivesNewsletter", value: "receivesNewsletter", label: "Send me occasional TeamSnap news.", extraProps: {
                    input: {
                        checked: receivesNewsletter,
                        onChange: () => {
                            setUser('receivesNewsletter', !receivesNewsletter);
                        },
                    },
                } }),
            React.createElement("div", { "data-testid": "termsAndConditionsAccepted", className: "sui-mb-2" },
                React.createElement(snap_ui_1.Checkbox, { name: "termsAndConditionsAccepted", value: "termsAndConditionsAccepted", extraProps: {
                        input: {
                            checked: termsAndConditionsAccepted,
                            onChange: () => setUser('termsAndConditionsAccepted', !termsAndConditionsAccepted),
                        },
                    }, errors: errors?.termsAndConditionsAccepted ? [errors.termsAndConditionsAccepted] : [] },
                    "I agree to TeamSnap's ",
                    React.createElement("a", { href: "https://teamsnap.com/terms", target: "_blank", rel: "noreferrer", className: "linkstyle" }, "Terms of Service"),
                    ' and ',
                    React.createElement("a", { href: "https://teamsnap.com/privacy-policy", target: "_blank", rel: "noreferrer", className: "linkstyle" }, "Privacy Policy"),
                    '.')),
            errors?.termsViolated && (React.createElement(snap_ui_1.Banner, { className: "sui-mb-2", sentiment: "negative", caption: "We cannot create your account at this time as it does not meet certain requirements outlined in our Terms of Service." })),
            React.createElement(snap_ui_1.LabelButton, { "data-testid": "continue-button", className: "sui-min-w-full sui-mb-2", labelText: "Continue", onClick: onSubmit, size: "default", variantType: "primary", disabled: errors?.termsViolated })),
        React.createElement("p", { className: "sui-body-dense sui-text-center sui-mt-3 sui-mb-0" }, "Already have an account?"),
        React.createElement(snap_ui_1.LabelButton, { "data-testid": "login-button", className: "sui-mb-3", style: { height: '2rem' }, labelText: "Log in", onClick: () => setLoginModalOpen(true), size: "default", variantType: "tertiary" }),
        React.createElement(LoginModal_1.LoginModal, { isOpen: loginModalOpen, onClose: () => setLoginModalOpen(false), onLogin: onLogin || (() => { }) })));
};
exports.default = CreateAccount;
